import { InnerPwaContext } from "./PwaProvider.js";
import { AddContactOverlay } from "./AddContactOverlay.js";
import { IOSAddToHomeOverlay } from "./IOSAddToHomeOverlay.js";
import { useContext } from "react";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";

//#region src/components/PwaOverlays.tsx
const PwaOverlays = () => {
	const { setShowAddToContacts, setShowIosInstallOverlay, showAddToContacts, showIosInstallOverlay } = useContext(InnerPwaContext);
	return /* @__PURE__ */ jsxs(Fragment, { children: [/* @__PURE__ */ jsx(IOSAddToHomeOverlay, {
		visible: showIosInstallOverlay,
		dismiss: () => setShowIosInstallOverlay(false)
	}), /* @__PURE__ */ jsx(AddContactOverlay, {
		visible: showAddToContacts,
		dismiss: () => setShowAddToContacts(false)
	})] });
};

//#endregion
export { PwaOverlays };